export const tapGPemail = "info@tapgp.co.uk";
export const tapGPSiteLabel = 'www.tapGP.co.uk';
export const tapGPSiteLink = 'https://tapgp.co.uk/';